var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    width: 26,
    height: 26
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#03B45F",
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#03B45F",
    strokeWidth: 1.075,
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M17.988 8l-6.113 6.697-2.863-2.901L7 13.946 11.875 19 20 10.15z"
  }))));
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjYgMjYiIHdpZHRoPSIyNiIgaGVpZ2h0PSIyNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxjaXJjbGUgZmlsbD0iIzAzQjQ1RiIgY3g9IjEzIiBjeT0iMTMiIHI9IjEzIi8+PHBhdGggc3Ryb2tlPSIjMDNCNDVGIiBzdHJva2Utd2lkdGg9IjEuMDc1IiBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xNy45ODggOGwtNi4xMTMgNi42OTctMi44NjMtMi45MDFMNyAxMy45NDYgMTEuODc1IDE5IDIwIDEwLjE1eiIvPjwvZz48L3N2Zz4K";
export { SvgCheckCircle as ReactComponent };